export default "__VITE_ASSET__75fvoxxM__"